import React, { useState } from 'react';
import { Divider } from '@mui/material';
import RodapeImgs from '../../../imgs/rodape-imgs.png';
import {
  AI_COLORS, AI_FONTS,
  PageHero, ContentWrap, Card, Modal,
} from '../shared';

const referencias = [
  'Lertpimonchai A, Rattanasiri S, Arj-Ong Vallibhakara S, Attia J, Thakkinstian A. The association between oral hygiene and periodontitis: a systematic review and meta-analysis. Int Dent J. 2017;67(6):332-43. doi:10.1111/idj.12317.',
  'Borg-Bartolo R, Roccuzzo A, Molinero-Mourelle P, Schimmel M, Gambetta-Tessini K, Chaurasia A, et al. Global prevalence of edentulism and dental caries in middle-aged and elderly persons: a systematic review and meta-analysis. J Dent. 2022;127:104335. doi:10.1016/j.jdent.2022.104335.',
  'Jepsen S, Berglundh T, Genco R, Aass AM, Demirel K, Derks J, et al. Primary prevention of peri-implantitis: managing peri-implant mucositis. J Clin Periodontol. 2015;42 Suppl 16:S152-7. doi:10.1111/jcpe.12369.',
  'Peres MA, Macpherson LMD, Weyant RJ, Daly B, Venturelli R, Mathur MR, et al. Oral diseases: a global public health challenge. Lancet. 2019;394(10194):249-60. doi:10.1016/S0140-6736(19)31146-8.',
  'Bouattour Y, Kalberer N, Chebib N, Mojon P, Mehl A, Srinivasan M, et al. Effects of overnight storage conditions on conventional complete removable prostheses. Int J Prosthodont. 2022;35(6):730-7. doi:10.11607/ijp.7158.',
  'Oliveira SSB, Mello CC, Coelho UP, Castro IO. A influência dos métodos de higiene na longevidade das próteses totais e parciais removíveis. Arch Health Invest. 2021;11(2):220-5. Disponível em: https://www.archhealthinvestigation.com.br/ARCHI/article/view/5584. Acesso em: 30 jun. 2026.',
  'Opstelten W, Neven AK, Eekhof J. Treatment and prevention of herpes labialis. Can Fam Physician. 2008;54(12):1683-7.',
  'Grippo JO, Simring M, Coleman TA. Abfraction, abrasion, biocorrosion, and the enigma of noncarious cervical lesions: a 20-year perspective. J Esthet Restor Dent. 2012;24(1):10-23. doi:10.1111/j.1708-8240.2011.00487.x.',
  'Lobbezoo F, Ahlberg J, Glaros AG, Kato T, Koyano K, Lavigne GJ, et al. Bruxism defined and graded: an international consensus. J Oral Rehabil. 2013;40(1):2-4. doi:10.1111/joor.12011.',
  'Villa A, Wolff A, Aframian D, Vissink A, Ekström J, Proctor G, et al. Medication-induced salivary gland dysfunction: prevalence, diagnosis, and treatment. Clin Oral Investig. 2015;19(7):1563-80. doi:10.1007/s00784-015-1488-2.',
  'Papapanou PN, Sanz M, Buduneli N, Dietrich T, Feres M, Fine DH, et al. Periodontitis: consensus report of workgroup 2 of the 2017 World Workshop. J Periodontol. 2018;89 Suppl 1:S173-82. doi:10.1002/JPER.17-0721.',
  'Wong TSC, Wiesenfeld D. Oral cancer. Aust Dent J. 2018;63 Suppl 1:S91-9. doi:10.1111/adj.12594.',
  'Lau CB, Smith GP. Recurrent aphthous stomatitis: a comprehensive review. Dermatol Ther. 2022;35(6):e15500. doi:10.1111/dth.15500.',
  'Assunção ELF, Rodrigues DCP, Oliveira LGA, Soares KH, Amaral FR, Alves SFF, et al. Lesões cervicais não cariosas em idosos. Arq Ciênc Saúde UNIPAR. 2025;29(3):1313-26.',
  'Rocha JS, Arima LY, Werneck RI, Moysés SJ, Baldani MH. Determinants of dental care attendance during pregnancy. Caries Res. 2018;52(1-2):139-52. doi:10.1159/000481407.',
  'Gil-Montoya JA, Rivero-Blanco T, Leon-Rios X, Exposito-Ruiz M, Pérez-Castillo I, Aguilar-Cordero MJ. Oral and general health conditions during pregnancy. Arch Gynecol Obstet. 2023;308(6):1765-73. doi:10.1007/s00404-022-06843-3.',
  'Sanz M, Ceriello A, Buysschaert M, Chapple I, Demmer RT, Graziani F, et al. Periodontal diseases and diabetes. Diabetes Res Clin Pract. 2018;137:231-41. doi:10.1016/j.diabres.2017.12.001.',
  'Czesnikiewicz-Guzik M, Osmenda G, Siedlinski M, Nosalski R, Pelka P, Nowakowski D, et al. Periodontitis and hypertension. Eur Heart J. 2019;40(42):3459-70. doi:10.1093/eurheartj/ehz646.',
  'Ministério da Saúde (BR). Guia alimentar para a população brasileira: promovendo a alimentação saudável. Brasília (DF): Ministério da Saúde; 2006.',
  'Belenda-Rodriguez I, Montero J. Bruxism, TMD and psychological factors. J Dent. 2025;156:105707. doi:10.1016/j.jdent.2025.105707.',
  'de Vries LP, van de Weijer MP, Bartels M. Physiology of well-being. Neurosci Biobehav Rev. 2022;139:104733. doi:10.1016/j.neubiorev.2022.104733.',
  'Lindau ST, Schumm LP, Laumann EO, Levinson W, O’Muircheartaigh CA, Waite LJ. Sexuality and health in older adults. N Engl J Med. 2007;357(8):762-74. doi:10.1056/NEJMoa067423.',
  'World Health Organization. Sexually transmitted infections (STIs) [Internet]. Geneva: WHO; 2025 [cited 2025 May 10]. Available from: https://www.who.int/news-room/fact-sheets/detail/sexually-transmitted-infections-(stis).',
  'Neville BW, Damm DD, Allen CM, Chi AC. Patologia oral e maxilofacial. 4. ed. Rio de Janeiro: Guanabara Koogan; 2016.',
  'Neville BW, Damm DD, Allen CM, Chi AC. Atlas de patologia oral e maxilofacial. 1. ed. Rio de Janeiro: Guanabara Koogan; 2021.',
  'Canva. Canva: plataforma de design gráfico online. Sydney: Canva Pty Ltd; 2026. Disponível em: https://www.canva.com/. Acesso em: 30 jun. 2026.',
  'Faveri M. Lesões cervicais não cariosas e recessões gengivais. Face Magazine. 2019. Disponível em: https://facemagazine.com.br/lesoes-cervicais-nao-cariosas-e-recessoes-gengivais/. Acesso em: 30 jun. 2026.',
  'Google Gemini. Vídeo gerado por inteligência artificial a partir de prompt elaborado pela autora. Mountain View: Google; 2026. Material não publicado.',
  'Ministério da Saúde (BR). Manual de saúde oral para o professor. Brasília (DF): Ministério da Saúde; 2012.',
  'Topeka Oral Surgery. Oral Pathology. Disponível em: https://topekaoralsurgery.com/oral-pathology/. Acesso em: 30 jun. 2026.',
];

export default function QuemSomos() {
  const [refsOpen, setRefsOpen] = useState(false);

  return (
    <div style={{ fontFamily: AI_FONTS.body, background: 'transparent' }}>
      <PageHero
        title="Quem somos?"
        subtitle="Uma iniciativa para oferecer aos adultos e idosos informações confiáveis, rápidas e de fácil acesso, essenciais para a promoção da saúde bucal."
      />

      <ContentWrap>
        <p style={{ lineHeight: 1.8, marginTop: 0 }}>
          Este website é uma iniciativa do diretor do Hospital Odontológico da Universidade Federal
          de Uberlândia (HOUFU), <strong>Professor Doutor Carlos José Soares</strong>, da{' '}
          <strong>Professora Doutora Jaqueline Vilela Bulgareli</strong>, e da mestranda{' '}
          <strong>Maria Angélica Sales Pires</strong> do Programa de Pós-Graduação da Faculdade de
          Odontologia da Universidade Federal de Uberlândia (PPGO-UFU), da Faculdade de Odontologia
          (FOUFU) e do Instituto Nacional de Ciência e Tecnologia Saúde Oral e Odontologia do
          município de Uberlândia (INCT-Odonto).
        </p>
        <p style={{ lineHeight: 1.8 }}>
          A proposta é oferecer aos adultos e idosos informações confiáveis, rápidas e de fácil
          acesso, essenciais para a promoção da saúde bucal.
        </p>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
            gap: 12,
            margin: '24px 0',
          }}
        >
          {['PPGO-UFU', 'HOUFU', 'FOUFU', 'INCT-Odonto'].map((sigla, i) => (
            <Card key={i} variant={i} style={{ textAlign: 'center', padding: '18px 14px' }}>
              <strong
                style={{
                  fontFamily: AI_FONTS.title,
                  color: AI_COLORS.blue900,
                  fontSize: '1.1rem',
                }}
              >
                {sigla}
              </strong>
            </Card>
          ))}
        </div>

        <div style={{ textAlign: 'center', margin: '24px 0' }}>
          <img
            src={RodapeImgs}
            alt="Instituições parceiras"
            style={{ maxWidth: 360, width: '100%', opacity: 0.9 }}
          />
        </div>

        <Divider style={{ margin: '32px 0', borderColor: AI_COLORS.bgBlue100 }} />

        <div style={{ textAlign: 'center' }}>
          <button
            onClick={() => setRefsOpen(true)}
            style={{
              padding: '12px 32px',
              background: AI_COLORS.blue800,
              color: AI_COLORS.white,
              border: 'none',
              borderRadius: 10,
              fontSize: '1rem',
              fontWeight: 700,
              cursor: 'pointer',
              fontFamily: AI_FONTS.body,
              boxShadow: '0 4px 14px rgba(1,87,155,0.18)',
            }}
          >
            📚 Referências
          </button>
        </div>
      </ContentWrap>

      {refsOpen && (
        <Modal title="Referências" onClose={() => setRefsOpen(false)}>
          <ol style={{ paddingLeft: 22, lineHeight: 1.7, margin: 0 }}>
            {referencias.map((ref, i) => (
              <li
                key={i}
                style={{ fontSize: '0.82rem', color: AI_COLORS.textMuted, marginBottom: 10 }}
              >
                {ref}
              </li>
            ))}
          </ol>
        </Modal>
      )}
    </div>
  );
}
